import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  CardVerification,
  CardVerificationApprove,
  CardVerificationApproveRequest,
  CardVerificationReject,
} from './types'
import { $params } from '../../../features/router'
import { cardVerificationStatus } from '../const'

export const cardVerificationRequestMounted = createEvent()
export const setCardVerificationRequest = createEvent<CardVerification>()
export const $cardVerificationRequest = restore(setCardVerificationRequest, {
  id: '',
  clientId: '',
  comment: '',
  expiry: '',
  fileNames: '',
  cardType: '',
  isCard: false,
  mask: '',
  status: '',
  token: '',
  type: '',
  verified: false,
  browserFileNames: [],
  client: {
    clientId: '',
    verified: false,
    email: '',
    firstName: '',
    fullName: '',
    lastName: '',
    middleName: '',
    country: '',
    isTest: false,
  },
})
export const submitApprove = createEvent<CardVerificationApprove>()
export const approveCardVerification = fx<
  CardVerificationApproveRequest,
  CardVerification
>({
  method: 'PUT',
  url: `/client_purse/`,
})

sample({
  clock: submitApprove,
  fn: ({ id }) => {
    return {
      body: {
        status: cardVerificationStatus.cardVerificationRequestStatusAccepted(),
      },
      url: `/client_purse/${id}`,
    }
  },
  target: approveCardVerification,
})
export const getCardVerification = fx<void, CardVerification>({
  method: 'GET',
  url: '/client_purse/',
})

export const changeCardVerificationStatus = fx<
  CardVerificationReject,
  CardVerification
>({
  method: 'PUT',
  url: '/client_purse/',
})

sample({
  clock: cardVerificationRequestMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.cardID
    }
    return {
      url: `/client_purse/${id}`,
    }
  },
  target: getCardVerification,
})

// update profile model

sample({
  clock: getCardVerification.doneData,
  fn: (doneData) => doneData.body,
  target: setCardVerificationRequest,
})

sample({
  clock: changeCardVerificationStatus.doneData,
  fn: (doneData) => doneData.body,
  target: setCardVerificationRequest,
})
